import { ITheme } from "../../../../utils/theme";

export const doubleUnderlineStyle = (theme: ITheme) => ({
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    height: '2px',
    background: theme.palette.clearBlue,
    boxShadow: `0px 3px 0px ${theme.palette.clearBlue}`
  }
})

export const bulletParagraphStyle = {
  position: "relative",
  pl: 2,
  mb: 1,
  "&::before": {
    content: '"•"',
    position: "absolute",
    left: 0,
    color: "#000",
    fontSize: "16px"
  }
}